import { render, staticRenderFns } from "./overview.vue?vue&type=template&id=fdabdce0&scoped=true&"
import script from "./overview.vue?vue&type=script&lang=js&"
export * from "./overview.vue?vue&type=script&lang=js&"
import style0 from "./overview.vue?vue&type=style&index=0&id=fdabdce0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdabdce0",
  null
  
)

export default component.exports